<template>
    <div>


        <v-sparkline :value="value" :gradient="gradient" :smooth="radius || false" :padding="padding"
            :line-width="width" :stroke-linecap="lineCap" :gradient-direction="gradientDirection" :fill="fill"
            :type="type" :auto-line-width="autoLineWidth" auto-draw label-size="4" :labels="labels" :show-labels="true">
           <!--  <template v-slot:label="item" >
                {{ item.value }}<br/> {{ item.value }}
            </template> -->
        </v-sparkline>




    </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";

@Component({
    name: "SparkLine",
    props: {
        value: {
            default: null,
        },
        keyValue: {
            default: null,
        },
        fill: {
            default: false,
        },
        customLabel: {
            default: false,
        },
        labels: {
            default: [],
        },
        width: {
            default: null,
        },
        radius: {
            default: null,
        },
        lineCap: {
            default: '',
        },
        gradient: {
            default: [],
        },
        gradientDirection: {
            default: 'top',
        },
        type: {
            default: 'trend',
        },
        autoLineWidth: {
            default: false,
        },



    }
})
export default class SparkLine extends Vue {





    // radius = 10;
    padding = 8;
    //lineCap = 'round';
    // gradient = ['#f72047', '#ffd200', '#1feaea'];
    gradients = [
        ['#222'],
        ['#42b3f4'],
        ['red', 'orange', 'yellow'],
        ['purple', 'violet'],
        ['#00c6ff', '#F0F', '#FF0'],
        ['#f72047', '#ffd200', '#1feaea'],
    ]

    /* gradientDirection = 'top';
    type = 'trend';
    autoLineWidth = false; */

    formatLabel(value) {
        console.log(value);
    }
}
</script>

<style>
.just-line-break {
    white-space: pre-line;
}

.line-break-and-tab {
    white-space: pre-wrap;
}

.heavy {
    font: bold 30px sans-serif;
}
</style>